import React from 'react';
import { Hero } from './components/Hero';
import { Features } from './components/Features';
import { Pricing } from './components/Pricing';
import { Footer } from './components/Footer';
export function App() {
  return <main className="min-h-screen w-full bg-white text-black overflow-x-hidden selection:bg-[#84cc16] selection:text-black" data-id="element-0">
      <nav className="fixed top-0 left-0 w-full z-50 bg-white/90 backdrop-blur-sm border-b border-gray-100" data-id="element-1">
        <div className="container mx-auto px-6 h-20 flex justify-between items-center" data-id="element-2">
          <div className="flex items-center space-x-2" data-id="element-3">
            <div className="w-6 h-6 bg-[#84cc16]" data-id="element-4" />
            <span className="font-black tracking-tight text-xl" data-id="element-5">
              JOUEURLIBRE
            </span>
          </div>
          <div className="hidden md:flex space-x-8 text-sm font-bold tracking-wide" data-id="element-6">
            <a href="#" className="hover:text-[#84cc16] transition-colors" data-id="element-7">
              SOLUTIONS
            </a>
            <a href="#" className="hover:text-[#84cc16] transition-colors" data-id="element-8">
              PRICING
            </a>
            <a href="#" className="hover:text-[#84cc16] transition-colors" data-id="element-9">
              ABOUT
            </a>
          </div>
          <button className="text-sm font-bold border-2 border-black px-4 py-2 hover:bg-black hover:text-white transition-colors" data-id="element-10">
            LOGIN
          </button>
        </div>
      </nav>

      <Hero data-id="element-11" />
      <Features data-id="element-12" />
      <Pricing data-id="element-13" />
      <Footer data-id="element-14" />
    </main>;
}